import { usersSearchMatches } from '@uplift/api';


export const usePatientsSearch = () => {
  return async (term: string) => {
    const { data: { users } } = await usersSearchMatches({ term: term });

    const result = users.map(({ match, user, profile }) => ({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      preferredName: profile.preferredName,
      active: match.state === 'active',
    }));

    return result;
  };
};
